import { Injectable } from '@angular/core';
import { Item } from '../core/components/listbox/listbox.component';
import { DataTaskService } from '../core/services/data-task.service';

@Injectable({
    providedIn: 'root'
})
export class OeeService {
    private reloaded = false;

    constructor(private datatask: DataTaskService) { }

    /**
    * Retrieves list of items.
    *
    * @datatask 256
    * @datataskName sp_ws_p2_oeedashboard_list
    * @param parms settings for the list to retrieve.
    * @returns promise containing list of functions.
    */
    public listOeeDashBoard(): Promise<Item[]> {
        return this.datatask.Post(256);
    }

    public reloadOeeDashboard(): boolean {
        this.reloaded = false;

        setTimeout(() => this.reloaded = true, 30000);

        return this.reloaded;
    }
}
